<template>
  <div>
    <h3>Project Search</h3>
    <div class="container">
        <form @submit.prevent="loadData" class="form-horizontal">
            <div class="form-group">
                <div class="col-sm-2">
                    <label for="searchName">Project Name</label>
                </div>
                <div class="col-sm-10">
                    <input class="form-control" type="text" name="searchName" v-model="projectSearchDto.name">
                </div>
            </div>
            <div class="form-group">
                <div class="col-sm-2">
                    <label for="searchDbNumber">DB Number</label>
                </div>
                <div class="col-sm-2">
                    <input class="form-control" type="text" name="searchRevNo" v-model="projectSearchDto.dbNumber">
                </div>
                <div class="col-sm-2 col-sm-offset-1">
                    <label for="searchRevNo">Rev No (legacy)</label>
                </div>
                <div class="col-sm-2">
                    <input class="form-control" type="text" name="searchRevNo" v-model="projectSearchDto.revNo">
                </div>
            </div>
            <div class="form-group">
                <div class="col-sm-2">
                    <label for="searchAgencyNumber">Agency Number</label>
                </div>
                <div class="col-sm-2">
                    <input class="form-control" type="text" name="searchAgencyNumber" v-model="projectSearchDto.agencyNumber">
                </div>
                <div class="col-sm-2 col-sm-offset-1">
                    <label for="searchAgencyName">Agency Name</label>
                </div>
                <div class="col-sm-5">
                <select name="searchAgencyName" class="form-control" v-model="projectSearchDto.agencyName">
                    <option value="">Select Agency Name</option>
                    <option v-for="organization in leadOrganizationList" :key="organization.organizationId" :value="organization.description">{{ organization.description}}</option>
                </select>
                </div>
            </div>
            <div class="form-group">
                <div class="col-sm-2">
                    <label for="searchfieldOrgNumber">Field Org. Number</label>
                </div>
                <div class="col-sm-2">
                    <input class="form-control" type="text" name="searchfieldOrgNumber" v-model="projectSearchDto.fieldOrgNumber">
                </div>
                <div class="col-sm-2 col-sm-offset-1">
                    <label for="searchFieldOrgName">Field Org. Name</label>
                </div>
                <div class="col-sm-5">
                    <select name="searchFieldOrgName" class="form-control" v-model="projectSearchDto.fieldOrgName">
                        <option value="">Select Field Organization Name</option>
                        <option v-for="organization in organizationList" :key="organization.organizationId" :value="organization.description">
                            {{ organization.description}}
                        </option>
                    </select>
                </div>
            </div>
            <div class="form-group">
                 <div class="col-sm-2">
                    <label for="searchProjectType">Project Type</label>
                </div>
                <div class="col-sm-3">
                    <input class="form-control" type="text" name="searchProjectType" v-model="projectSearchDto.projectType">
                </div>
                <div class="col-sm-2">
                    <label for="searchClientName">Client Name</label>
                </div>
                <div class="col-sm-5">
                    <select name="searchClientName" class="form-control" v-model="projectSearchDto.clientName">
                        <option value="">Select Client Name</option>
                        <option v-for="organization in organizationList" :key="organization.organizationId" :value="organization.description">
                            {{ organization.description}}
                        </option>
                    </select>
                </div>
            </div>
            <div class="form-group">
                <div class="col-sm-2">
                    <label class="form-check-label" for="showInactive">Show Inactives</label>
                </div>
                <div class="col-sm-3">
                    <input class="form-check-input" type="checkbox" v-model="projectSearchDto.showInactive" style="width: 20px; height: 20px;">
                </div>
                <div class="col-sm-2">
                    <label for="searchFieldOrgName">Created Date Range</label>
                </div>
                <div class="col-sm-2">
                    <el-date-picker v-model="projectSearchDto.startDate" type="date" format="MM/dd/yyyy" placeholder="From Date"></el-date-picker>
                </div>
                <div class="col-sm-2">
                    <el-date-picker v-model="projectSearchDto.endDate" type="date" format="MM/dd/yyyy" placeholder="To Date"></el-date-picker>
                </div>
            </div>
            <div class="form-group form-check" v-show="isShpo">
                <div class="col-sm-2">
                    <label class="form-check-label" for="showE106">Show E106 Only</label>
                </div>
                <div class="col-sm-4">
                    <input class="form-check-input" type="checkbox" v-model="projectSearchDto.showE106Only" style="width: 20px; height: 20px;">
                </div>
            </div>
            <div class="form-group">
                <div class="col-md-2">
                    <button class="btn btn-primary" type="submit" name="button" v-on:click="loadData">Search</button>
                </div>
            </div>
        </form>
    </div>
    <div class="wrapper">
      <div  class="row row-wider">
        <div class="col-md-12">
          <div class="pull-right" v-if="!formDisabled">
            <router-link to="/Project" tag="button" class="btn btn-primary btn-block">Add New</router-link>
          </div>
          <loader v-if="loading"/>
          <div>
            <v-client-table :data="gridSpec.tableData" :columns="gridSpec.columns" :options="gridSpec.options">
              <template slot="edit" slot-scope="props">
                <div style="text-align: center;">
                    <router-link :to="{ path: '/Project/' + props.row.projectId }" tag="a" class="fa fa-edit" style="font-size: 18px;"></router-link>
                </div>
              </template>
            </v-client-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import loggingService from '../services/util/loggingService'
import projectService from '../services/projectService'
import roleService from '@/services/roleService.js'
import userService from '@/services/userService'
import projectTypeService from '../services/lookup/projectTypeService'
import organizationService from '../services/organizationService'
import { mapState } from 'vuex'

import loader from '../components/Loader.vue'

export default {
    components: {
        loader
    },
    data () {
        return {
            isDebug: false,
            loading: true,
            list: null,
            projectSearchDto: {
                showInactive: false,
                name: '',
                dbNumber: '',
                revNo: '',
                agencyNumber: '',
                agencyName: '',
                clientName: '',
                fieldOrgNumber: '',
                fieldOrgName: '',
                projectType: '',
                startDate: null,
                endDate: null
            },
            gridSpec: {
                columns: ['edit', 'name', 'dbNumber', 'revNo', 'projectTypeDescription', 'agencyDescription', 'agencyNumber', 'clientDescription', 'fieldOrgDescription', 'fieldOrgNumber', 'createdDate'],
                tableData: [],
                options: {
                    dateFormat: 'YYYY-MM-DD',
                    perPage: 10,
                    perPageValues: [10, 25, 50, 100],
                    dateColumns: ['createdDate'],
                    headings: {
                        edit: 'View/Edit',
                        dbNumber: 'DB Number',
                        revNo: 'Rev No',
                        projectTypeDescription: 'Type',
                        agencyDescription: 'Agency',
                        agencyNumber: 'Agency No',
                        clientDescription: 'Client',
                        fieldOrgDescription: 'Field Org.',
                        fieldOrgNumber: 'Field Org. Number',
                        createdDate: 'Created Date'
                    },
                    orderBy: {
                        ascending: false,
                        column: 'createdDate'
                    }
                }
            },
            leadOrganizationList: [],
            organizationList: [],
            projectTypeList: []
        }
    },
    computed: {
        ...mapState({
            shpoUserDto: state => state.auth.shpoUserDto
        }),
        shpoRoleList: function () {
            let list = []
            for (let prop in roleService.RoleEnum) {
                if (prop.includes('Administrator') || prop.includes('Shpo')) {
                    list.push(roleService.RoleEnum[prop])
                }
            }
            return list
        },
        isShpo: function () {
            return (this.shpoUserDto && userService.hasRoleCheck(this.shpoUserDto.roleList, this.shpoRoleList))
        },
        isCLGConsultant: function () {
            return (userService.hasRoleCheck(this.shpoUserDto.roleList, [roleService.RoleEnum.CLGConsultant]))
        },
        formDisabled: function () {
            return userService.hasRoleCheck(this.shpoUserDto.roleList, roleService.RestrictedRoleList)
        }
    },
    mounted () {
        loggingService.log(this.isDebug, 'Projects', 'mounted')

        this.loadData().then(result => {
            Promise.all([ this.loadLeadOrganizationList(), this.loadOrganizations(), this.loadProjectTypeList() ])
        })
    },
    methods: {
        loadData () {
            loggingService.log(this.isDebug, 'Projects', 'loadData')

            var handle = this
            handle.list = null
            return projectService.search(this.$http, this.projectSearchDto).then(function (response) {
                loggingService.log(handle.isDebug, 'Projects', 'projectService.search.then')

                handle.gridSpec.tableData = response.data
                handle.loading = false
            })
        },
        // editRow (id) {
        //     loggingService.log(this.isDebug, 'Projects', 'editRow, id: ' + id)

        //     this.$router.push('/Project/' + id)
        // },
        loadLeadOrganizationList () {
            loggingService.log(this.isDebug, 'Project', 'loadLeadOrganizationList')
            this.leadOrganizationList = []
            var handle = this
            return organizationService.listLeadAgencyLookup(handle.$http).then(function (response) {
                handle.leadOrganizationList = response.data
            })
        },
        loadOrganizations () {
            loggingService.log(this.isDebug, 'Project', 'loadOrganizations')
            this.organizationList = []
            var handle = this
            return organizationService.listLookup(this.$http).then(function (response) {
                handle.organizationList = response.data
            })
        },
        loadProjectTypeList () {
            loggingService.log(this.isDebug, 'Project', 'loadProjectTypeList')
            this.projectTypeList = []
            var handle = this
            return projectTypeService.listLookup(this.$http).then(function (response) {
                handle.projectTypeList = response.data
                if (handle.isCLGConsultant) {
                    handle.projectTypeList = handle.projectTypeList.filter(x => x.description === 'HPF Programs--Survey')
                }
            })
        }
    }
}
</script>



// WEBPACK FOOTER //
// Projects.vue?08db908d